import { Directive, HostBinding, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { ILadderItem } from '../acca-boost-ladder-carousel/base-acca-boost-ladder-carousel.component';

@Directive()
export class BaseAccaBoostCarouselItemComponent {
    @Input() model: ILadderItem;
    @Input() picksCount: number;
    @Input() itemCount: number;

    @HostBinding('class') className = 'carousel-item carousel-item__wrapper';

    @HostBinding('class.carousel-item--included') get includedClass(): boolean {
        return this.model.included;
    }

    @HostBinding('class.carousel-item--selected') get selectedClass(): boolean {
        return this.model.selected;
    }

    constructor(protected sitecore: Sitecore) {}
}
